import {Component, OnInit} from '@angular/core';
import {AppConstants} from '../../../../helpers/core/AppConstants';
import {ReportService} from '../../../../services/authenticated/report/report.service';
import {Emitters} from '../../../../helpers/core/emitters';
import {ResponseModel} from '../../../../models/response/response.model';
import {DataSharing} from '../../../../helpers/core/data.sharing'
@Component({
    selector: 'app-distance-report',
    templateUrl: './distance.report.component.html',
})
export class DistanceReportComponent implements OnInit {
    public level_info:any;
    public _wssp_ids_based;
    constructor(public reportService: ReportService, private emitters: Emitters) {
    }

    ngOnInit() {
        this.level_info = DataSharing.level_info();
        this._wssp_ids_based = false;
        const user_id = DataSharing.user_id();
        // let user_ids = AppConstants.WSSP_USER_IDS;
        // let exist = user_ids.some(existingId => existingId === user_id);
        const domain_id = DataSharing.domain_id();

        if(domain_id=='16'){
            this._wssp_ids_based=true;
        }
    }

    public onSubmit(data) {
        this.getReport(data);
    }

    public exportReport() {
        this.reportService.exportReportFn('distance-report');
    }

    private getReport(data) {
        this.reportService.distance(data).then((response: ResponseModel) => {
            if (response.status) {
                this.reportService.reportData = response.data;
                this.emitters.change({get_report: true});
            }
        });
    }
}
